export const DEVICE_TYPE_COLORS: Record<string, string> = {
  kiosk: 'blue',
  reader: 'green',
  printer: 'purple',
  display: 'orange',
  default: 'gray',
};

export const DEVICE_TYPE_NAMES = {
  KIOSK: 'kiosk',
  READER: 'reader',
  PRINTER: 'printer',
  DISPLAY: 'display',
} as const;

export const MESSAGES = {
  DEVICE_CREATED: 'Device created successfully.',
  DEVICE_UPDATED: 'Device updated successfully.',
  DEVICE_DELETED: 'Device deleted successfully.',
  ERROR_CREATE: 'Failed to create device.',
  ERROR_UPDATE: 'Failed to update device.',
  ERROR_DELETE: 'Failed to delete device.',
  ERROR_FETCH_DEVICES: 'Error fetching devices.',
  ERROR_FETCH_DEVICE_TYPES: 'Error fetching device types.',
  ERROR_FETCH_MERCHANTS: 'Error fetching merchants.',
  ERROR_FETCH_STORES: 'Error fetching stores.',
  DATABASE_SCHEMA_ERROR: 'The devices API is experiencing a database schema issue. Please contact the backend team to fix the missing \'staffPin\' column in the merchant table.',
  UNSAVED_CHANGES: 'You have unsaved changes. Are you sure you want to cancel?',
  NO_DEVICES_FOUND: 'No devices found',
  ADJUST_SEARCH: 'Try adjusting your search or filter criteria',
  ADD_FIRST_DEVICE: 'Get started by adding your first device',
} as const;

export const VALIDATION_MESSAGES = {
  NAME_REQUIRED: 'Name is required',
  IDENTIFIER_REQUIRED: 'Identifier is required',
  TYPE_REQUIRED: 'Device type is required',
} as const;

export const PLACEHOLDERS = {
  SEARCH: 'Search devices, stores, or merchants...',
  FILTER_TYPE: 'Filter by Device Type',
  SELECT_TYPE: 'Select device type',
  SELECT_MERCHANT: 'Select merchant',
  SELECT_STORE: 'Select Store',
} as const;

export const LABELS = {
  DEVICE_MANAGER: 'Device Manager',
  DEVICE_MANAGER_DESC: 'Manage kiosks, readers, and other devices across your stores',
  ADD_DEVICE: 'Add Device',
  NAME: 'Name',
  IDENTIFIER: 'Identifier',
  DEVICE_TYPE: 'Device Type',
  MERCHANT: 'Merchant',
  STORE: 'Store',
  BACK: 'Back',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  SAVING: 'Saving...',
  UNSAVED_CHANGES: 'Unsaved Changes',
  YES: 'Yes',
  NO: 'No',
  KIOSK_READER_CONNECTIONS: 'Kiosk-Reader Connections',
  CONNECTED: 'Connected',
  INCOMPLETE_PAIR: 'Incomplete Pair',
  OTHER_DEVICES: 'Other Devices',
  TOTAL_DEVICES: 'Total Devices',
  EDIT_KIOSK: 'Edit Kiosk',
  EDIT_READER: 'Edit Reader',
  EDIT_DEVICE: 'Edit Device',
  DELETE_KIOSK: 'Delete Kiosk',
  DELETE_READER: 'Delete Reader',
  DELETE_DEVICE: 'Delete Device',
  MANAGE_CONNECTION: 'Manage Connection',
  NO_KIOSK: 'No Kiosk',
  NO_READER: 'No Reader',
  UNASSIGNED: 'Unassigned',
  KIOSK: 'Kiosk',
  READER: 'Reader',
} as const;
